export default __webpack_public_path__ + "static/media/MinimumBuyValuesNoMatch.30cc1ebf.png";